import clsx from "clsx"
import { FC, useEffect } from "react"
import { useAppDispatch } from "store"
import { useTranslation } from "react-i18next"
import { TAGS } from "store/api"
import { NY_GIFT_MY_BEHAVIOR_TYPE, nyGiftApi } from "store/apis/nyGiftAPI"
import { useModals } from "context/modals/hooks/useModals"
import useServerTimer from "hooks/useServerTimer"
import { useNyGift } from "hooks/useNyGift/useNyGift"
import { formatTimer } from "helpers/formatTimer"
import { dayjsServer } from "utils/dayjsServer"
import { OutlinedTextV3 } from "ui/OutlinedText-v3"
import { giftIcon } from "assets/icons"
import { SideMenuItem } from "../side-menu-item"
import styles from "./index.module.scss"

export const SideMenuWinterGift: FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { nyGiftMyBehaviorData, isAvailableToClaimGift } = useNyGift()
  const { openModal } = useModals()

  const { days, hours, minutes, seconds, restart } = useServerTimer({
    expiryTimestamp: new Date(),
    onExpire: () => {
      dispatch(
        nyGiftApi.util.invalidateTags([
          { type: TAGS.NY_GIFT, id: "MY_BEHAVIOR" }
        ])
      )
    }
  })

  const handleClick = () => {
    openModal(isAvailableToClaimGift ? "giftClaim" : "giftInfo")
  }

  useEffect(() => {
    if (!nyGiftMyBehaviorData) return

    restart(
      dayjsServer(
        nyGiftMyBehaviorData.gift[
          isAvailableToClaimGift ? "claimableTo" : "claimableFrom"
        ]
      ).toDate()
    )
  }, [nyGiftMyBehaviorData])

  return (
    <div className={clsx(styles.SideMenuWinterGift)}>
      <SideMenuItem
        id="btn-winter-gift"
        name="winter-gift"
        color={
          nyGiftMyBehaviorData?.gift.yourBehavior ===
          NY_GIFT_MY_BEHAVIOR_TYPE.BEST
            ? "#40D4F8"
            : "#FCB53A"
        }
        icon={giftIcon}
        title={t("nyGift.gift")}
        onClick={handleClick}
      />
      <OutlinedTextV3 className={clsx(styles.SideMenuWinterGift_time)}>
        {formatTimer(days, hours, minutes, seconds, t)}
      </OutlinedTextV3>
    </div>
  )
}
